import React, { useState, useEffect } from 'react';
import { hasCachedImage, getCachedImage, cacheImage } from '../../common/cache/mediaCache';

const CachedImage = ({ src, alt, style, defaultSrc, ...props }) => {
  // Initialize state with cached image if available
  const [imageSrc, setImageSrc] = useState(() => (hasCachedImage(src) ? getCachedImage(src) : null));
  const [isLoading, setIsLoading] = useState(!imageSrc);

  useEffect(() => {
    // If source changes, reset loading state and check cache
    if (hasCachedImage(src)) {
      setImageSrc(getCachedImage(src));
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    // If not in cache, fetch the image
    const fetchImage = async () => {
      try {
        // Fetch the image and convert to blob URL
        const response = await fetch(src);
        const blob = await response.blob();
        const objectURL = URL.createObjectURL(blob);

        // Store in our cache
        cacheImage(src, objectURL);
        setImageSrc(objectURL);
      } catch (error) {
        console.error('Error loading image:', error);
        // Fallback to original source on error
        setImageSrc(src);
      } finally {
        setIsLoading(false);
      }
    };

    fetchImage();
  }, [src]);

  // Show placeholder while loading
  if (isLoading) {
    return null;
  }

  return <img src={imageSrc} alt={alt} style={style} {...props} />;
};

export default CachedImage;
